<template>
    <div>
        <popup :is-set-styled="false" :show="popups.ruleCategory.show" :name="popups.ruleCategory.name" :width="400"
               :add-class="'add-cat add-cat-uppercase'">
            <rule-category></rule-category>
        </popup>

        <popup :is-set-styled="false" :show="popups.removeRule.show" :name="popups.removeRule.name" :width="512">
            <remove-rule></remove-rule>
        </popup>

        <popup :is-set-styled="false" :show="popups.removeRuleForever.show" :name="popups.removeRuleForever.name"
               :width="512">
            <remove-rule-forever></remove-rule-forever>
        </popup>

        <popup :is-set-styled="false" :show="popups.removeRules.show" :name="popups.removeRules.name" :width="512">
            <remove-rules></remove-rules>
        </popup>

        <popup :is-set-styled="false" :show="popups.tryingUpdate.show" :name="popups.tryingUpdate.name" :width="400"
               :is-btn-close="false">
            <trying-update @autoSave="ruleSend"></trying-update>
        </popup>

        <popup :is-set-styled="false" :show="popups.errorScreenUpload.show" :name="popups.errorScreenUpload.name"
               :width="512">
            <error-upload></error-upload>
        </popup>

        <popup :is-set-styled="false" :show="popups.errorSchemeUpload.show" :name="popups.errorSchemeUpload.name"
               :width="512">
            <error-upload-scheme></error-upload-scheme>
        </popup>

        <popup :is-set-styled="false" :show="popups.removeCatError.show" :name="popups.removeCatError.name"
               :width="400" :is-btn-close="false">
            <remove-cat-error></remove-cat-error>
        </popup>

        <!-- В данный момент редактирования недоступно -->
        <popup :is-set-styled="false" :show="popups.editDisabled.show" :name="popups.editDisabled.name" :width="512"
               :is-btn-close="false">
            <edit-disabled></edit-disabled>
        </popup>

        <!-- В данный момент удаление недоступно -->
        <popup :is-set-styled="false" :show="popups.removeDisabled.show" :name="popups.removeDisabled.name"
               :width="512" :is-btn-close="false">
            <remove-disabled></remove-disabled>
        </popup>

        <!-- В данный момент редактирования недоступно -->
        <popup :is-set-styled="false" :show="popups.editAdminDisabled.show" :name="popups.editAdminDisabled.name"
               :width="512" :is-btn-close="false">
            <edit-admin-disabled></edit-admin-disabled>
        </popup>

        <popup :is-set-styled="false" :show="popups.recoverRule.show" :name="popups.recoverRule.name" :width="424"
               :add-class="'recover-modal'">
            <recover-rule :recoverItem="recoverItem"></recover-rule>
        </popup>

        <popup :is-set-styled="false" :show="popups.ruleType.show" :name="popups.ruleType.name" :width="512">
            <rule-type></rule-type>
        </popup>

        <popup :is-set-styled="false" :show="popups.exitWithoutSave.show" :name="popups.exitWithoutSave.name"
               :width="512">
            <exit-without-save @apply="exitWithoutSave"/>
        </popup>
    </div>
</template>

<script>
import {mapState} from 'vuex';
import Popup from '@/components/modal/Popup.vue';
import RuleCategory from '@/components/modal/rules/RuleCategory.vue';
import RemoveRule from '@/components/modal/rules/RemoveRule.vue';
import RemoveRuleForever from '@/components/modal/rules/RemoveRuleForever.vue';
import ErrorUpload from '@/components/modal/rules/ErrorUpload.vue';
import TryingUpdate from '@/components/modal/rules/TryingUpdate.vue';
import ErrorUploadScheme from '@/components/modal/rules/ErrorUploadScheme.vue';
import RemoveRules from '@/components/modal/rules/RemoveRules.vue';
import RecoverRule from '@/components/modal/rules/RecoverRule.vue';
import ExitWithoutSave from '@/components/modal/rules/ExitWithoutSave.vue';
import RemoveCatError from '@/components/modal/rules/RemoveCatError.vue';
import EditDisabled from '@/components/modal/rules/EditDisabled.vue';
import RemoveDisabled from '@/components/modal/rules/RemoveDisabled.vue';
import RuleType from '@/components/modal/rules/RuleType.vue';
import EditAdminDisabled from '@/components/modal/rules/EditAdminDisabled.vue';

export default {
    name: "RulesPopups",
    components: {
        Popup,
        RuleCategory,
        RemoveRule,
        RemoveRuleForever,
        ErrorUpload,
        TryingUpdate,
        ErrorUploadScheme,
        RemoveRules,
        RecoverRule,
        ExitWithoutSave,
        RemoveCatError,
        EditDisabled,
        RemoveDisabled,
        RuleType,
        EditAdminDisabled,
    },
    props: {
        recoverItem: {
            default(){
                return {}
            }
        }
    },
    computed: {
        ...mapState({
                popups: state => state.popups.items,
        }),
    },
    methods: {
        exitWithoutSave: function () {
            this.$emit('apply');
        },
        ruleSend(data) {
            this.$emit('autoSave', data);
        },
    }
}
</script>

<style scoped>

</style>